var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal__container-inner"},[_c('div',{staticClass:"add-key-modal add-key-modal__wrapper"},[_c('h3',{staticClass:"modal__title title-h4"},[_vm._v(" "+_vm._s(_vm.$t('modals.choose_key_type'))+" ")]),_c('EuKey')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }